define(["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.importIdb = importIdb;

  // @ts-check

  /**
   * Temporary workaround until browsers get import-maps
   * @returns {Promise<import("idb")>}
   */
  async function importIdb() {
    try {
      return await new Promise(resolve => require(["idb"], resolve));
    } catch (_unused) {
      return await new Promise(resolve => require(["../../node_modules/idb/build/esm/index.js"], resolve));
    }
  }
});
//# sourceMappingURL=idb.js.map